import { render, staticRenderFns } from "./ImageInpaintingEditor.vue?vue&type=template&id=6ca78c26&scoped=true&"
import script from "./ImageInpaintingEditor.vue?vue&type=script&lang=js&"
export * from "./ImageInpaintingEditor.vue?vue&type=script&lang=js&"
import style0 from "./ImageInpaintingEditor.vue?vue&type=style&index=0&id=6ca78c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca78c26",
  null
  
)

export default component.exports